import React, { useState, useEffect, useMemo } from 'react';
import {
    LayoutDashboard, MessageSquare, Users, PhoneCall, Calendar, ClipboardList,
    Plus, Filter, ChevronLeft, ChevronRight, ExternalLink, Download, Settings,
    X, ChevronDown, Calendar as CalendarIcon, AlignLeft, Undo, Redo, Maximize,
    Minus, Paperclip, Smile, Send, Mic, Type, Italic, Strikethrough, Underline, Link as LinkIcon, Droplet, Eraser, Bold,
    Menu, Sun, Moon, FileText, Clock, User
} from 'lucide-react';
import { Table, ConfigProvider, theme } from 'antd';
import Layout from '../../Layout'

const contractsData = [
    {
        id: 1,
        creatorAvatar: "T",
        creatorBg: "bg-cyan-700",
        contractCode: "BP09-02-02360",
        staffName: "Đặng Thị Tới",
        department: "Tài chính - Kế toán",
        contractName: "[Tiền] Hợp đồng không xác định",
        digitalSign: "Chưa tạo",
        signStatus: "--",
        signCompleteDate: "--",
        signDate: "01/04/2026",
        effectiveFrom: "01/04/2026",
        effectiveTo: "--",
        status: "Đang hiệu lực",
        createdAt: "13/08/2026",
        customerType: "Nhân sự nội bộ"
    },
    {
        id: 2,
        creatorAvatar: "https://placehold.co/28x28/333/fff?text=H",
        isImg: true,
        contractCode: "HQ_495-01-02359",
        staffName: "Mr. Huân",
        department: "CÔNG TY CỔ PHẦN KHOTHI",
        contractName: "Hợp đồng 3 năm (Khách hàng VIP)",
        digitalSign: "Đã tạo",
        signStatus: "Hoàn tất",
        signCompleteDate: "12/08/2026",
        signDate: "12/08/2026",
        effectiveFrom: "12/08/2026",
        effectiveTo: "11/08/2029",
        status: "Đang hiệu lực",
        createdAt: "12/08/2026",
        customerType: "Khách hàng doanh nghiệp"
    },
    {
        id: 3,
        creatorAvatar: "https://placehold.co/28x28/444/fff?text=V",
        isImg: true,
        contractCode: "HQ_494-01-02358",
        staffName: "Vũ Ngọc 4",
        department: "Phòng kinh doanh",
        contractName: "(VTKT) Hợp đồng lao động 12 tháng",
        digitalSign: "Chưa tạo",
        signStatus: "--",
        signCompleteDate: "--",
        signDate: "--",
        effectiveFrom: "10/08/2026",
        effectiveTo: "09/08/2027",
        status: "Đang hiệu lực",
        createdAt: "10/08/2026",
        customerType: "Nhân sự nội bộ"
    },
    {
        id: 4,
        creatorAvatar: "M",
        creatorBg: "bg-emerald-700",
        contractCode: "KH_882-03-01991",
        staffName: "Nguyễn Minh Quân",
        department: "Khách hàng cá nhân - Miền Nam",
        contractName: "Hợp đồng Dịch vụ Khách hàng Premium",
        digitalSign: "Đã tạo",
        signStatus: "Đang chờ ký",
        signCompleteDate: "--",
        signDate: "15/07/2025",
        effectiveFrom: "15/07/2025",
        effectiveTo: "15/07/2026",
        status: "Hết hiệu lực",
        createdAt: "15/07/2025",
        customerType: "Khách hàng cá nhân"
    },
    {
        id: 5,
        creatorAvatar: "A",
        creatorBg: "bg-indigo-700",
        contractCode: "KH_883-03-01992",
        staffName: "Công ty TNHH Giải pháp Số Á Châu",
        department: "Khách hàng Doanh nghiệp Key Account",
        contractName: "Hợp đồng Cung cấp Giải pháp ERP Doanh nghiệp",
        digitalSign: "Đã tạo",
        signStatus: "Hoàn tất",
        signCompleteDate: "01/01/2025",
        signDate: "01/01/2025",
        effectiveFrom: "01/01/2025",
        effectiveTo: "31/12/2025",
        status: "Hết hiệu lực",
        createdAt: "01/01/2025",
        customerType: "Khách hàng doanh nghiệp"
    },
    {
        id: 6,
        creatorAvatar: "P",
        creatorBg: "bg-amber-700",
        contractCode: "NS_102-04-02401",
        staffName: "Phạm Hoàng Long",
        department: "Phòng Công nghệ thông tin",
        contractName: "Hợp đồng thử việc 2 tháng",
        digitalSign: "Chưa tạo",
        signStatus: "--",
        signCompleteDate: "--",
        signDate: "--",
        effectiveFrom: "01/09/2026",
        effectiveTo: "31/10/2026",
        status: "Chưa hiệu lực",
        createdAt: "14/08/2026",
        customerType: "Nhân sự nội bộ"
    },
    {
        id: 7,
        creatorAvatar: "L",
        creatorBg: "bg-purple-700",
        contractCode: "KH_901-05-02102",
        staffName: "Lê Thị Thảo Nguyên",
        department: "Khách hàng Bán lẻ Cao cấp",
        contractName: "Hợp đồng Mua bán Thiết bị Định kỳ",
        digitalSign: "Đã tạo",
        signStatus: "Đang chờ ký",
        signCompleteDate: "--",
        signDate: "--",
        effectiveFrom: "01/09/2026",
        effectiveTo: "01/09/2027",
        status: "Chưa hiệu lực",
        createdAt: "14/08/2026",
        customerType: "Khách hàng cá nhân"
    },
    {
        id: 8,
        creatorAvatar: "N",
        creatorBg: "bg-rose-700",
        contractCode: "TL_301-01-01550",
        staffName: "Ngô Văn Tuấn",
        department: "Phòng Kinh doanh Miền Bắc",
        contractName: "Hợp đồng Lao động (Đã thanh lý trước hạn)",
        digitalSign: "Đã tạo",
        signStatus: "Hoàn tất",
        signCompleteDate: "10/01/2024",
        signDate: "10/01/2024",
        effectiveFrom: "15/01/2024",
        effectiveTo: "15/01/2027",
        status: "Thanh lý",
        createdAt: "10/01/2024",
        customerType: "Nhân sự nội bộ"
    },
    {
        id: 9,
        creatorAvatar: "https://placehold.co/28x28/555/fff?text=C",
        isImg: true,
        contractCode: "TL_302-02-01600",
        staffName: "Tập đoàn Đầu tư Bất động sản An Phát",
        department: "Khách hàng Chiến lược",
        contractName: "Thanh lý Hợp đồng Tư vấn Dự án Xây dựng",
        digitalSign: "Đã tạo",
        signStatus: "Hoàn tất",
        signCompleteDate: "20/06/2025",
        signDate: "20/06/2025",
        effectiveFrom: "01/01/2024",
        effectiveTo: "30/06/2025",
        status: "Thanh lý",
        createdAt: "20/06/2025",
        customerType: "Khách hàng doanh nghiệp"
    }
];

const StatusBadge = ({ status }) => {
    let baseClass = "px-2 py-0.5 rounded text-[11px] font-semibold whitespace-nowrap inline-block ";
    if (status === 'Đang hiệu lực') baseClass += 'bg-emerald-100 text-emerald-700 dark:bg-emerald-500/20 dark:text-emerald-400';
    else if (status === 'Hết hiệu lực') baseClass += 'bg-slate-100 text-slate-700 dark:bg-slate-700 dark:text-slate-300';
    else if (status === 'Chưa hiệu lực') baseClass += 'bg-amber-100 text-amber-700 dark:bg-amber-500/20 dark:text-amber-400';
    else if (status === 'Thanh lý') baseClass += 'bg-rose-100 text-rose-700 dark:bg-rose-500/20 dark:text-rose-400';

    return <span className={baseClass}>{status}</span>;
};

const Sidebar = ({ isOpen, setIsOpen }) => {
    return (
        <>
            {/* Mobile Overlay */}
            <div
                className={`fixed inset-0 bg-black/50 z-30 lg:hidden transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}
                onClick={() => setIsOpen(false)}
            />

            {/* Sidebar Content */}
            <aside className={`fixed lg:static inset-y-0 left-0 z-40 w-64 bg-white dark:bg-slate-900 border-r border-slate-200 dark:border-slate-800 flex flex-col flex-shrink-0 transition-transform duration-300 ${isOpen ? 'translate-x-0' : '-translate-x-full lg:translate-x-0'}`}>
                {/* Logo */}
                <div className="h-16 flex items-center px-6 border-b border-slate-100 dark:border-slate-800 flex-shrink-0">
                    <div className="flex items-center gap-2">
                        <div className="w-8 h-8 rounded bg-cyan-700 flex items-center justify-center text-white font-bold text-lg">K</div>
                        <div>
                            <span className="font-extrabold text-cyan-900 dark:text-cyan-400 tracking-wider text-base">KHO THI</span>
                            <span className="block text-[9px] text-slate-400 dark:text-slate-500 tracking-tighter uppercase">Since 2003</span>
                        </div>
                    </div>
                </div>

                {/* Menu */}
                <div className="flex-1 overflow-y-auto py-4 px-3 space-y-1 text-sm no-scrollbar">
                    <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                        <LayoutDashboard className="w-5 h-5 text-slate-500 dark:text-slate-400" />
                        <span className="font-medium">Tổng quan</span>
                    </a>

                    <div className="pt-3 pb-1 px-3 text-[11px] font-bold text-slate-400 dark:text-slate-500 uppercase tracking-wider">CMS</div>

                    <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                        <MessageSquare className="w-5 h-5 text-slate-500 dark:text-slate-400" />
                        <span>Chats</span>
                    </a>
                    <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                        <Users className="w-5 h-5 text-slate-500 dark:text-slate-400" />
                        <span>Khách hàng</span>
                    </a>
                    <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                        <PhoneCall className="w-5 h-5 text-slate-500 dark:text-slate-400" />
                        <span>Contact Center</span>
                    </a>
                    <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                        <Calendar className="w-5 h-5 text-slate-500 dark:text-slate-400" />
                        <span>Lịch hẹn</span>
                    </a>
                    <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-700 dark:text-slate-300 hover:bg-slate-50 dark:hover:bg-slate-800 transition-colors">
                        <MessageSquare className="w-5 h-5 text-slate-500 dark:text-slate-400" />
                        <span>Lịch Tư Vấn</span>
                    </a>
                    <a href="#" className="flex items-center gap-3 px-3 py-2.5 rounded-lg text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-[#3e91ab]/10 font-medium transition-colors">
                        <ClipboardList className="w-5 h-5 text-orange-600 dark:text-orange-400" />
                        <span>Lịch Thực Hiện</span>
                    </a>
                </div>
            </aside>
        </>
    );
};

const CreateModal = ({ isOpen, onClose }) => {
    const [salaryRows, setSalaryRows] = useState([
        { id: 1, type: 'Lương', name: 'Mức lương hiệu quả công việc', amount: '1,000,000' }
    ]);

    const addSalaryRow = () => {
        setSalaryRows([...salaryRows, { id: Date.now(), type: 'Phụ cấp', name: 'Khoản phụ cấp bổ sung', amount: '500,000' }]);
    };

    const removeRow = (id) => {
        setSalaryRows(salaryRows.filter(r => r.id !== id));
    };

    return (
        <div className={`fixed inset-0 z-[100] flex justify-end transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            <div className="absolute inset-0 bg-black/40 backdrop-blur-[1px]" onClick={onClose} />
            <div className={`relative bg-white dark:bg-slate-900 w-full max-w-2xl h-full shadow-2xl flex flex-col transform transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>
                {/* Header */}
                <div className="px-6 py-4 border-b border-slate-200 dark:border-slate-800 flex items-center justify-between bg-slate-50 dark:bg-slate-800/50 flex-shrink-0">
                    <h3 className="font-bold text-base text-slate-800 dark:text-slate-100">Thêm mới hợp đồng nhân viên</h3>
                    <button type="button" onClick={onClose} className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-1 rounded-full transition-colors">
                        <X size={20} />
                    </button>
                </div>

                {/* Body */}
                <div className="flex-1 overflow-y-auto p-6 space-y-6 custom-scrollbar">
                    {/* Section 1 */}
                    <div>
                        <h4 className="text-xs font-bold text-[#3e91ab] uppercase tracking-wider mb-4 flex items-center gap-2">
                            <ChevronDown size={14} /> Thông tin chung
                        </h4>
                        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                            <div className="relative border border-slate-300 dark:border-slate-600 rounded p-2 focus-within:border-[#3e91ab] dark:focus-within:border-[#3e91ab] transition-colors">
                                <label className="block text-[11px] text-slate-400 dark:text-slate-500">Mã HĐ *</label>
                                <input type="text" defaultValue="HQ_500-01-02361" className="w-full text-xs outline-none text-slate-800 dark:text-slate-100 bg-transparent font-medium mt-0.5" />
                            </div>
                            <div className="relative border border-slate-300 dark:border-slate-600 rounded p-2 focus-within:border-[#3e91ab] dark:focus-within:border-[#3e91ab] flex items-center justify-between transition-colors">
                                <div className="flex-1">
                                    <label className="block text-[11px] text-slate-400 dark:text-slate-500">Loại hợp đồng *</label>
                                    <select className="w-full text-xs outline-none text-slate-800 dark:text-slate-100 bg-transparent mt-0.5 appearance-none">
                                        <option className="dark:bg-slate-800">Chọn loại hợp đồng</option>
                                        <option className="dark:bg-slate-800" selected>Hợp đồng lao động 12 tháng</option>
                                        <option className="dark:bg-slate-800">Hợp đồng không xác định thời hạn</option>
                                    </select>
                                </div>
                                <ChevronDown size={14} className="text-slate-400 absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none" />
                            </div>
                            <div className="relative border border-slate-300 dark:border-slate-600 rounded p-2 focus-within:border-[#3e91ab] md:col-span-2 flex items-center justify-between transition-colors">
                                <div className="flex-1">
                                    <label className="block text-[11px] text-slate-400">Phòng ban</label>
                                    <input type="text" defaultValue="Phòng Điều Hành" className="w-full text-xs outline-none text-slate-800 dark:text-slate-100 bg-transparent mt-0.5" />
                                </div>
                                <button type="button" className="text-slate-400 hover:text-slate-600"><X size={14} /></button>
                            </div>
                            <div className="relative border border-slate-300 dark:border-slate-600 rounded p-2 focus-within:border-[#3e91ab] md:col-span-2 flex items-center justify-between transition-colors">
                                <div className="flex-1">
                                    <label className="block text-[11px] text-slate-400">Vị trí</label>
                                    <input type="text" defaultValue="ADD1 - nhân viên HC-NS" className="w-full text-xs outline-none text-slate-800 dark:text-slate-100 bg-transparent mt-0.5" />
                                </div>
                                <button type="button" className="text-slate-400 hover:text-slate-600"><X size={14} /></button>
                            </div>
                            <div className="relative border border-slate-300 dark:border-slate-600 rounded p-2 focus-within:border-[#3e91ab] md:col-span-2 transition-colors">
                                <input type="text" placeholder="Hệ số tay nghề" className="w-full text-xs outline-none text-slate-800 dark:text-slate-100 bg-transparent py-1" />
                            </div>
                            <div className="relative border border-slate-300 dark:border-slate-600 rounded p-2 focus-within:border-[#3e91ab] flex items-center justify-between transition-colors">
                                <div className="flex-1">
                                    <label className="block text-[11px] text-slate-400">Hiệu lực từ ngày *</label>
                                    <input type="text" defaultValue="15/08/2026" className="w-full text-xs outline-none text-slate-800 dark:text-slate-100 bg-transparent font-medium mt-0.5" />
                                </div>
                                <CalendarIcon size={14} className="text-slate-400" />
                            </div>
                            <div className="relative border border-slate-300 dark:border-slate-600 rounded p-2 focus-within:border-[#3e91ab] flex items-center justify-between transition-colors">
                                <div className="flex-1">
                                    <label className="block text-[11px] text-slate-400">Đến ngày</label>
                                    <input type="text" placeholder="dd/mm/yyyy" className="w-full text-xs outline-none text-slate-800 dark:text-slate-100 bg-transparent mt-0.5" />
                                </div>
                                <CalendarIcon size={14} className="text-slate-400" />
                            </div>
                        </div>
                    </div>

                    {/* Section 2 */}
                    <div className="pt-4 border-t border-slate-100 dark:border-slate-800">
                        <h4 className="text-xs font-bold text-[#3e91ab] uppercase tracking-wider mb-4 flex items-center gap-2">
                            <ChevronDown size={14} /> Thông tin lương và phụ cấp
                        </h4>
                        <div className="bg-slate-50 dark:bg-slate-800/30 p-4 rounded-lg border border-slate-200 dark:border-slate-700 space-y-4">
                            <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
                                <div>
                                    <label className="block text-[11px] text-slate-500 dark:text-slate-400 mb-1">Từ ngày <span className="text-red-500">*</span></label>
                                    <div className="relative border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 rounded p-2 flex items-center justify-between">
                                        <input type="text" defaultValue="15/08/2026" className="w-full text-xs outline-none bg-transparent font-medium dark:text-slate-100" />
                                        <CalendarIcon size={14} className="text-slate-400" />
                                    </div>
                                </div>
                                <div>
                                    <label className="block text-[11px] text-slate-500 dark:text-slate-400 mb-1">Ghi chú</label>
                                    <div className="relative border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 rounded p-2 flex items-center justify-between">
                                        <input type="text" placeholder="..." className="w-full text-xs outline-none bg-transparent dark:text-slate-100" />
                                    </div>
                                </div>
                            </div>

                            <div className="space-y-3">
                                {salaryRows.map(row => (
                                    <div key={row.id} className="flex flex-col sm:flex-row items-start sm:items-center gap-2">
                                        <div className="w-full sm:flex-1 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 rounded p-2 flex items-center gap-2">
                                            <span className="text-xs text-slate-700 dark:text-slate-300 flex-shrink-0">{row.type}</span>
                                            <button className="text-slate-400 hover:text-slate-600"><X size={12} /></button>
                                            <span className="text-slate-300 dark:text-slate-600">|</span>
                                            <span className="text-xs text-slate-700 dark:text-slate-300 truncate flex-1">{row.name}</span>
                                            <button className="text-slate-400 hover:text-slate-600"><X size={12} /></button>
                                        </div>
                                        <div className="w-full sm:w-36 border border-slate-300 dark:border-slate-600 bg-white dark:bg-slate-900 rounded p-2 flex items-center justify-between flex-shrink-0">
                                            <input type="text" defaultValue={row.amount} className="w-full text-xs outline-none bg-transparent font-medium dark:text-slate-100" />
                                            <button onClick={() => removeRow(row.id)} className="text-slate-400 hover:text-slate-600 ml-1"><X size={12} /></button>
                                        </div>
                                    </div>
                                ))}
                            </div>
                            <div>
                                <button onClick={addSalaryRow} className="w-7 h-7 rounded-full border border-[#3e91ab] text-[#3e91ab] flex items-center justify-center hover:bg-orange-50 dark:hover:bg-[#3e91ab]/20 transition-colors">
                                    <Plus size={14} />
                                </button>
                            </div>
                        </div>
                    </div>

                    {/* Section 3 (Rich Text) */}
                    <div className="pt-4 border-t border-slate-100 dark:border-slate-800">
                        <label className="block text-xs font-bold text-[#3e91ab] mb-2">Ghi chú</label>
                        <div className="border border-[#3e91ab]/50 dark:border-[#3e91ab]/30 rounded-lg overflow-hidden bg-white dark:bg-slate-900">
                            <div className="bg-slate-50 dark:bg-slate-800/80 border-b border-slate-200 dark:border-slate-700 px-3 py-2 flex flex-wrap gap-3 text-slate-500 dark:text-slate-400 text-xs items-center">
                                <button className="hover:text-slate-800 dark:hover:text-slate-200"><Mic size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200"><Type size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200"><Smile size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200"><LinkIcon size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200"><Droplet size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200"><Eraser size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200 font-bold"><Bold size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200 italic"><Italic size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200 line-through"><Strikethrough size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200 underline"><Underline size={14} /></button>
                                <button className="hover:text-orange-600 text-orange-600 dark:bg-[#3e91ab]/20 p-1 rounded"><AlignLeft size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200 dark:bg-[#3e91ab]/20 text-orange-600 p-1 rounded"><Undo size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200"><Redo size={14} /></button>
                                <button className="hover:text-slate-800 dark:hover:text-slate-200"><Maximize size={14} /></button>
                            </div>
                            <div className="p-3 min-h-[120px] text-xs text-slate-800 dark:text-slate-200 outline-none" contentEditable suppressContentEditableWarning>
                                Thông tin bổ sung...
                            </div>
                        </div>
                    </div>
                </div>

                {/* Footer */}
                <div className="px-6 py-3 border-t border-slate-200 dark:border-slate-800 bg-slate-50 dark:bg-slate-800/50 flex items-center justify-end gap-3 flex-shrink-0">
                    <button onClick={onClose} className="px-4 py-2 border border-slate-300 dark:border-slate-600 rounded text-xs font-semibold text-slate-700 dark:text-slate-300 hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors">Hủy</button>
                    <button onClick={onClose} className="px-4 py-2 bg-[#3e91ab] hover:bg-orange-600 text-white rounded text-xs font-semibold shadow-sm transition-colors">Lưu</button>
                </div>
            </div>
        </div>
    );
};

const DetailModal = ({ contract, isOpen, onClose }) => {
    const [tab, setTab] = useState('chat');

    if (!contract) return null;

    return (
        <div className={`fixed inset-0 z-[100] flex justify-end transition-opacity duration-300 ${isOpen ? 'opacity-100' : 'opacity-0 pointer-events-none'}`}>
            <div className="absolute inset-0 bg-black/40 backdrop-blur-[1px]" onClick={onClose} />
            <div className={`relative bg-slate-50 dark:bg-slate-950 w-full max-w-6xl h-full shadow-2xl flex flex-col transform transition-transform duration-300 ${isOpen ? 'translate-x-0' : 'translate-x-full'}`}>

                {/* Header */}
                <div className="px-6 py-3 border-b border-slate-200 dark:border-slate-800 bg-white dark:bg-slate-900 flex items-center justify-between flex-shrink-0">
                    <div className="flex items-center gap-3">
                        <span className="text-xs font-bold text-slate-800 dark:text-slate-100">Chi tiết hợp đồng nhân sự</span>
                    </div>
                    <button onClick={onClose} className="text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 p-1 rounded-full"><X size={20} /></button>
                </div>

                {/* Body Content */}
                <div className="flex-1 overflow-y-auto p-4 md:p-6 flex flex-col lg:flex-row gap-6 custom-scrollbar">

                    {/* Left Column */}
                    <div className="flex-[7] space-y-5">

                        {/* Info Block 1 */}
                        <div className="bg-white dark:bg-slate-900 rounded border border-slate-200 dark:border-slate-800 p-5 shadow-sm">
                            <div className="flex justify-between items-center mb-4 border-b border-slate-100 dark:border-slate-800 pb-2">
                                <h3 className="text-xs font-bold text-slate-800 dark:text-slate-100 uppercase tracking-wider">Thông tin chung</h3>
                                <button className="text-slate-400 hover:text-slate-600"><Minus size={14} /></button>
                            </div>
                            <div className="grid grid-cols-1 sm:grid-cols-2 gap-y-4 gap-x-8 text-xs">
                                <div>
                                    <span className="text-slate-400 block mb-1">Mã HĐ</span>
                                    <p className="text-slate-800 dark:text-slate-200 font-medium">{contract.contractCode}</p>
                                </div>
                                <div>
                                    <span className="text-slate-400 block mb-1">Tên nhân sự</span>
                                    <span className="inline-block dark:bg-[#3e91ab]/20 text-orange-700 dark:text-orange-400 px-2.5 py-0.5 rounded font-medium">{contract.staffName}</span>
                                </div>
                                <div>
                                    <span className="text-slate-400 block mb-1">Tên hợp đồng</span>
                                    <p className="text-slate-800 dark:text-slate-200 font-medium">{contract.contractName}</p>
                                </div>
                                <div>
                                    <span className="text-slate-400 block mb-1">Phòng ban</span>
                                    <p className="text-slate-800 dark:text-slate-200 font-medium">{contract.department}</p>
                                </div>
                                <div>
                                    <span className="text-slate-400 block mb-1">Hiệu lực từ ngày</span>
                                    <p className="text-slate-800 dark:text-slate-200 font-medium">{contract.effectiveFrom} đến {contract.effectiveTo !== '--' ? contract.effectiveTo : 'Không xác định'}</p>
                                </div>
                                <div>
                                    <span className="text-slate-400 block mb-1">Tình trạng</span>
                                    <StatusBadge status={contract.status} />
                                </div>
                            </div>
                        </div>

                        {/* Info Block 2: Salary */}
                        <div className="bg-white dark:bg-slate-900 rounded border border-slate-200 dark:border-slate-800 p-5 shadow-sm">
                            <div className="flex justify-between items-center mb-4 border-b border-slate-100 dark:border-slate-800 pb-2">
                                <h3 className="text-xs font-bold text-slate-800 dark:text-slate-100 uppercase tracking-wider">Lương và phụ cấp</h3>
                                <button className="text-slate-400 hover:text-slate-600"><Minus size={14} /></button>
                            </div>
                            <div className="overflow-x-auto no-scrollbar">
                                <table className="w-full text-left text-xs whitespace-nowrap">
                                    <thead>
                                        <tr className="text-slate-400 border-b border-slate-100 dark:border-slate-800">
                                            <th className="pb-2 font-medium">Từ ngày</th>
                                            <th className="pb-2 font-medium">(KHOTHI) Phụ cấp ăn uống</th>
                                            <th className="pb-2 font-medium">(KHOTHI) Phụ cấp dịch vụ</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr className="text-slate-800 dark:text-slate-200">
                                            <td className="py-3 font-medium">01/01/2026</td>
                                            <td className="py-3">300,000 / Tháng</td>
                                            <td className="py-3">3,000,000 / Tháng</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>

                        {/* Info Block 3: Relations */}
                        <div className="bg-white dark:bg-slate-900 rounded border border-slate-200 dark:border-slate-800 p-5 shadow-sm">
                            <div className="flex justify-between items-center mb-4 border-b border-slate-100 dark:border-slate-800 pb-2">
                                <h3 className="text-xs font-bold text-slate-800 dark:text-slate-100 uppercase tracking-wider">Liên quan</h3>
                            </div>
                            <div className="border border-slate-200 dark:border-slate-700 rounded-lg p-4 bg-slate-50/50 dark:bg-slate-800/30">
                                <div className="flex items-center gap-3 mb-3">
                                    <div className="w-8 h-8 rounded-full bg-slate-200 dark:bg-slate-700 flex items-center justify-center text-slate-500 dark:text-slate-300"><User size={14} /></div>
                                    <div>
                                        <h4 className="text-xs font-bold text-slate-800 dark:text-slate-100">{contract.staffName}</h4>
                                        <span className="text-[10px] text-slate-400 flex items-center gap-1">Lê Việt Thắng <Clock size={10} /> 09:55 ng 19/7/2026</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    {/* Right Column: Chat/History */}
                    <div className="flex-[5] bg-white dark:bg-slate-900 rounded border border-slate-200 dark:border-slate-800 overflow-hidden flex flex-col h-[600px] lg:h-[calc(100vh-120px)] lg:sticky lg:top-0 shadow-sm">

                        {/* Tabs */}
                        <div className="px-2 pt-3 border-b border-slate-100 dark:border-slate-800 flex justify-between items-center bg-white dark:bg-slate-900 flex-shrink-0">
                            <div className="flex gap-4 px-3 overflow-x-auto no-scrollbar">
                                <button
                                    onClick={() => setTab('chat')}
                                    className={`pb-3 text-sm whitespace-nowrap transition-colors border-b-2 ${tab === 'chat' ? 'font-bold text-[#3e91ab] border-[#3e91ab]' : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 border-transparent'}`}
                                >
                                    Thảo luận (2)
                                </button>
                                <button
                                    onClick={() => setTab('history')}
                                    className={`pb-3 text-sm whitespace-nowrap transition-colors border-b-2 ${tab === 'history' ? 'font-bold text-[#3e91ab] border-[#3e91ab]' : 'text-slate-500 hover:text-slate-700 dark:text-slate-400 border-transparent'}`}
                                >
                                    Lịch sử hoạt động (3)
                                </button>
                            </div>
                        </div>

                        {/* Tab Content */}
                        <div className="flex-1 overflow-y-auto bg-slate-50/50 dark:bg-slate-800/20 p-4 custom-scrollbar">
                            {tab === 'chat' && (
                                <div className="flex flex-col gap-4">
                                    <div className="flex items-start gap-3">
                                        <div className="w-8 h-8 rounded-full bg-[#3e91ab] text-white flex items-center justify-center font-bold text-xs flex-shrink-0">HA</div>
                                        <div className="flex-1 bg-white dark:bg-slate-800 p-3 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm">
                                            <div className="flex justify-between items-center mb-1">
                                                <span className="text-xs font-bold text-slate-800 dark:text-slate-100">Hà Anh</span>
                                                <span className="text-[10px] text-slate-400">10:15 - 15/08/2026</span>
                                            </div>
                                            <p className="text-xs text-slate-700 dark:text-slate-300">Đã cập nhật lại mức lương mới. Mọi người kiểm tra nhé!</p>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-3">
                                        <img src="https://placehold.co/30x30/333/fff?text=T" className="w-8 h-8 rounded-full object-cover flex-shrink-0" alt="avatar" />
                                        <div className="flex-1 bg-white dark:bg-slate-800 p-3 rounded-lg border border-slate-200 dark:border-slate-700 shadow-sm">
                                            <div className="flex justify-between items-center mb-1">
                                                <span className="text-xs font-bold text-slate-800 dark:text-slate-100">{contract.staffName}</span>
                                                <span className="text-[10px] text-slate-400">11:00 - 15/08/2026</span>
                                            </div>
                                            <p className="text-xs text-slate-700 dark:text-slate-300">Mình đã xác nhận thông tin hợp đồng.</p>
                                            <div className="mt-2 flex items-center gap-2 p-2 bg-slate-50 dark:bg-slate-900 border border-slate-200 dark:border-slate-700 rounded text-xs text-slate-600 dark:text-slate-300">
                                                <FileText size={14} className="text-red-500" />
                                                <span className="truncate">Hop_dong_lao_dong_signed.pdf</span>
                                                <a href="#" className="text-[#3e91ab] hover:underline ml-auto flex-shrink-0">Tải xuống</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            )}

                            {tab === 'history' && (
                                <div className="flex flex-col gap-3">
                                    <div className="flex items-start gap-3 text-xs border-l-2 border-[#3e91ab] pl-3 py-1">
                                        <div>
                                            <p className="text-slate-800 dark:text-slate-200"><span className="font-bold">Hà Anh</span> đã tạo mới hợp đồng.</p>
                                            <span className="text-[10px] text-slate-400">15/08/2026 09:30</span>
                                        </div>
                                    </div>
                                    <div className="flex items-start gap-3 text-xs border-l-2 border-emerald-500 pl-3 py-1">
                                        <div>
                                            <p className="text-slate-800 dark:text-slate-200"><span className="font-bold">Hệ thống</span> chuyển trạng thái sang <span className="text-emerald-600 font-bold">Đang hiệu lực</span>.</p>
                                            <span className="text-[10px] text-slate-400">15/08/2026 11:05</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>

                        {/* Input Area */}
                        <div className="p-3 bg-white dark:bg-slate-900 border-t border-slate-100 dark:border-slate-800 flex-shrink-0">
                            <div className="border border-slate-300 dark:border-slate-700 rounded-full flex items-center px-3 py-2 bg-white dark:bg-slate-800 focus-within:border-[#3e91ab] transition-all shadow-sm">
                                <input type="text" placeholder="Viết thảo luận..." className="flex-1 text-xs text-slate-800 dark:text-slate-200 bg-transparent outline-none pl-2" />
                                <div className="flex items-center gap-2.5 text-slate-400 ml-2">
                                    <button className="hover:text-[#3e91ab]"><Paperclip size={14} /></button>
                                    <button className="hover:text-[#3e91ab]"><Smile size={14} /></button>
                                    <button className="hover:text-[#3e91ab]"><Send size={14} /></button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};


const AppContent = ({ darkMode, setDarkMode }) => {
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const [filter, setFilter] = useState('all');

    // Modals
    const [isCreateOpen, setIsCreateOpen] = useState(false);
    const [detailContractId, setDetailContractId] = useState(null);

    // Derived Data
    const filteredData = useMemo(() => {
        if (filter === 'all') return contractsData;
        return contractsData.filter(item => item.status === filter);
    }, [filter]);

    const counts = useMemo(() => ({
        all: contractsData.length,
        'Đang hiệu lực': contractsData.filter(i => i.status === 'Đang hiệu lực').length,
        'Hết hiệu lực': contractsData.filter(i => i.status === 'Hết hiệu lực').length,
        'Chưa hiệu lực': contractsData.filter(i => i.status === 'Chưa hiệu lực').length,
        'Thanh lý': contractsData.filter(i => i.status === 'Thanh lý').length,
    }), []);

    const tabs = [
        { key: 'all', label: 'Tất cả' },
        { key: 'Đang hiệu lực', label: 'Đang hiệu lực' },
        { key: 'Hết hiệu lực', label: 'Hết hiệu lực' },
        { key: 'Chưa hiệu lực', label: 'Chưa hiệu lực' },
        { key: 'Thanh lý', label: 'Thanh lý' },
    ];

    const selectedContract = contractsData.find(c => c.id === detailContractId);

    // Ant Design Table Columns Configuration
    const columns = [
        {
            title: 'Người tạo',
            dataIndex: 'creator',
            key: 'creator',
            fixed: 'left',
            width: 110,
            render: (_, record) => (
                <div className="flex items-center">
                    {record.isImg ? (
                        <img src={record.creatorAvatar} className="w-7 h-7 rounded-full object-cover" alt="avatar" />
                    ) : (
                        <div className={`w-7 h-7 rounded-full ${record.creatorBg} text-white flex items-center justify-center font-bold text-xs`}>
                            {record.creatorAvatar}
                        </div>
                    )}
                </div>
            ),
        },
        {
            title: 'Mã HĐ',
            dataIndex: 'contractCode',
            key: 'contractCode',
            fixed: 'left',
            width: 140,
            render: (text) => <span className="font-medium text-slate-900 dark:text-slate-100">{text}</span>,
        },
        {
            title: 'Tên nhân sự',
            dataIndex: 'staffName',
            key: 'staffName',
            width: 180,
            render: (text, record) => (
                <button
                    onClick={() => setDetailContractId(record.id)}
                    className="text-orange-600 dark:text-orange-400 bg-orange-50 dark:bg-[#3e91ab]/10 px-2 py-0.5 rounded font-medium hover:underline text-left truncate max-w-full block"
                >
                    {text}
                </button>
            ),
        },
        {
            title: 'Phòng ban',
            dataIndex: 'department',
            key: 'department',
            width: 200,
            ellipsis: true,
        },
        {
            title: 'Tên hợp đồng',
            dataIndex: 'contractName',
            key: 'contractName',
            width: 250,
            ellipsis: true,
        },
        {
            title: 'Đã tạo ký số',
            dataIndex: 'digitalSign',
            key: 'digitalSign',
            width: 120,
        },
        {
            title: 'Trạng thái ký',
            dataIndex: 'signStatus',
            key: 'signStatus',
            width: 130,
            render: (text) => <span className={text === '--' ? 'text-slate-400' : ''}>{text}</span>,
        },
        {
            title: 'Hoàn tất ký số',
            dataIndex: 'signCompleteDate',
            key: 'signCompleteDate',
            width: 130,
            render: (text) => <span className={text === '--' ? 'text-slate-400' : ''}>{text}</span>,
        },
        {
            title: 'Ngày ký',
            dataIndex: 'signDate',
            key: 'signDate',
            width: 110,
            render: (text) => <span className={text === '--' ? 'text-slate-400' : ''}>{text}</span>,
        },
        {
            title: 'Hiệu lực từ',
            dataIndex: 'effectiveFrom',
            key: 'effectiveFrom',
            width: 120,
        },
        {
            title: 'Đến ngày',
            dataIndex: 'effectiveTo',
            key: 'effectiveTo',
            width: 110,
            render: (text) => <span className={text === '--' ? 'text-slate-400' : ''}>{text}</span>,
        },
        {
            title: 'Tình trạng',
            dataIndex: 'status',
            key: 'status',
            width: 130,
            render: (status) => <StatusBadge status={status} />,
        },
        {
            title: 'Ngày tạo',
            dataIndex: 'createdAt',
            key: 'createdAt',
            width: 110,
        },
    ];

    return (
        <div className="flex h-screen w-full overflow-hidden font-sans text-slate-800 dark:text-slate-100 antialiased selection:bg-[#3e91ab]/30">
            {/* Main Area */}
            <main className="flex-1 flex flex-col h-screen overflow-hidden w-full relative z-10">

                {/* Header Tabs & Actions */}
                <header className="border-b border-slate-200 dark:border-slate-800 flex items-center justify-between flex-shrink-0 h-14 w-full">
                    <div className="flex items-center gap-4 md:gap-6 overflow-x-auto no-scrollbar w-full">
                        <button className="lg:hidden text-slate-500 hover:text-slate-700 dark:text-slate-400" onClick={() => setSidebarOpen(true)}>
                            <Menu size={20} />
                        </button>

                        <div className="flex items-center space-x-4 md:space-x-6 text-sm font-medium">
                            {tabs.map(tab => (
                                <button
                                    key={tab.key}
                                    onClick={() => setFilter(tab.key)}
                                    className={`pb-4 pt-4 whitespace-nowrap transition-colors border-b-2 ${filter === tab.key
                                        ? 'text-[#3e91ab] border-[#3e91ab] font-bold'
                                        : 'text-slate-500 dark:text-slate-400 hover:text-slate-700 dark:hover:text-slate-200 border-transparent'
                                        }`}
                                >
                                    {tab.label} ({counts[tab.key]})
                                </button>
                            ))}
                        </div>
                    </div>
                    <div className="flex items-center gap-3 pl-4">
                        <button onClick={() => setIsCreateOpen(true)} className="bg-[#3e91ab] text-white px-3.5 py-1.5 rounded text-xs font-semibold flex items-center gap-1.5 shadow-sm transition-all whitespace-nowrap">
                            <Plus size={14} /> <span className="hidden sm:inline">Tạo mới HĐ</span>
                        </button>
                    </div>
                </header>

                {/* Toolbar */}
                <div className="px-4 py-2.5 border-b border-slate-200 dark:border-slate-800 flex items-center justify-between flex-shrink-0 text-xs w-full overflow-x-auto no-scrollbar">
                    <div className="flex items-center gap-3 text-slate-600 dark:text-slate-400 whitespace-nowrap">
                        <button className="hover:text-[#3e91ab]"><Filter size={14} /></button>
                        <span>Hiển thị 1 - {filteredData.length} / {filteredData.length} bản ghi</span>
                    </div>
                    <div className="flex items-center gap-4 text-slate-600 dark:text-slate-400 whitespace-nowrap">
                        <span className="hidden sm:inline">Trang: 01 / 01</span>
                        <div className="flex items-center gap-1">
                            <button className="p-1 hover:bg-slate-200 dark:hover:bg-slate-700 rounded disabled:opacity-40" disabled><ChevronLeft size={14} /></button>
                            <button className="p-1 hover:bg-slate-200 dark:hover:bg-slate-700 rounded"><ChevronRight size={14} /></button>
                        </div>
                        <div className="h-4 w-px bg-slate-300 dark:bg-slate-600 mx-1 hidden sm:block"></div>
                        <button className="hover:text-slate-900 dark:hover:text-slate-100 flex items-center gap-1"><ExternalLink size={14} /> <span className="hidden sm:inline">Export</span></button>
                        <button className="hover:text-slate-900 dark:hover:text-slate-100 flex items-center gap-1"><Download size={14} /> <span className="hidden sm:inline">Import</span></button>
                        <button className="hover:text-slate-900 dark:hover:text-slate-100 flex items-center gap-1"><Settings size={14} /> <span className="hidden sm:inline">Cài đặt</span></button>
                    </div>
                </div>

                {/* Ant Design Table Container */}
                <div className="flex-1 overflow-auto custom-scrollbar p-0">
                    <ConfigProvider
                        theme={{
                            algorithm: darkMode ? theme.darkAlgorithm : theme.defaultAlgorithm,
                            token: {
                                colorPrimary: '#f97316', // orange-500
                                colorBgContainer: darkMode ? '#0f172a' : '#ffffff', // slate-900 / white
                                colorText: darkMode ? '#f1f5f9' : '#334155', // slate-100 / slate-700
                                colorBorderSecondary: darkMode ? '#334155' : '#e2e8f0', // slate-700 / slate-200
                                borderRadius: 0,
                            },
                            components: {
                                Table: {
                                    headerBg: darkMode ? '#1e293b' : '#f8fafc', // slate-800 / slate-50
                                    headerColor: darkMode ? '#cbd5e1' : '#475569', // slate-300 / slate-600
                                    rowHoverBg: darkMode ? '#1e293b' : '#fff7ed', // slate-800 / orange-50
                                    cellPaddingBlock: 12,
                                    cellPaddingInline: 12,
                                    headerBorderRadius: 0,
                                }
                            }
                        }}
                    >
                        <Table
                            columns={columns}
                            dataSource={filteredData}
                            rowKey="id"
                            scroll={{ x: 'max-content', y: 'calc(100vh - 170px)' }}
                            pagination={false}
                            rowSelection={{
                                type: 'checkbox',
                                columnWidth: 50,
                                fixed: 'left'
                            }}
                            size="small"
                            className="custom-antd-table"
                        />
                    </ConfigProvider>
                </div>
            </main>

            <CreateModal isOpen={isCreateOpen} onClose={() => setIsCreateOpen(false)} />
            <DetailModal contract={selectedContract} isOpen={!!detailContractId} onClose={() => setDetailContractId(null)} />
        </div>
    );
};

export default function App() {
    const [darkMode, setDarkMode] = useState(false);

    // Apply dark class to html root to ensure sandboxes render correctly if body relies on it.
    useEffect(() => {
        if (darkMode) {
            document.documentElement.classList.add('dark');
        } else {
            document.documentElement.classList.remove('dark');
        }
    }, [darkMode]);

    return (
        <Layout>
            <style>{`
                .custom-scrollbar::-webkit-scrollbar { width: 6px; height: 6px; }
                .custom-scrollbar::-webkit-scrollbar-track { background: transparent; }
                .custom-scrollbar::-webkit-scrollbar-thumb { background: #cbd5e1; border-radius: 3px; }
                .dark .custom-scrollbar::-webkit-scrollbar-thumb { background: #475569; }
                .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #94a3b8; }
                .dark .custom-scrollbar::-webkit-scrollbar-thumb:hover { background: #64748b; }
                .no-scrollbar::-webkit-scrollbar { display: none; }
                .no-scrollbar { -ms-overflow-style: none; scrollbar-width: none; }
                
                /* Custom styles to override some ant design defaults for better integration */
                .custom-antd-table .ant-table-thead > tr > th {
                    font-weight: 600;
                    text-transform: uppercase;
                    font-size: 12px;
                    border-bottom: 1px solid var(--border-color);
                }
                .custom-antd-table .ant-table-tbody > tr > td {
                    font-size: 12px;
                    border-bottom: 1px solid var(--border-color);
                }
                .dark .custom-antd-table {
                    --border-color: #334155;
                }
                .custom-antd-table {
                    --border-color: #e2e8f0;
                }
                /* Hide ant design default empty text if needed or style it */
                .ant-empty-description {
                    color: inherit;
                }
            `}</style>
            <AppContent darkMode={darkMode} setDarkMode={setDarkMode} />
        </Layout>
    );
}